<div class="kpi-icon" [ngClass]="colorClass()">
  <tidy-image [src]="icon()" />
</div>
<div class="kpi-body">
  <tidy-text [helper]="label()" class="kpi-label" />
  <tidy-text [body]="value()" class="kpi-value bold" />
  @if (caption()) {
    <tidy-text [helper]="caption()" class="kpi-caption" />
  }
</div>
